export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "PersonnelMasterImportWorker.1e788c0dde886c34196a.worker.js");
}
